module.exports = __webpack_public_path__ + "static/img/propile-top-background.a09fd4f5.jpg";